export default __webpack_public_path__ + "static/media/Specyfikacja_Click&Link_Cubo_gril.1530dc2c.pdf";